/* global google */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/lazyload.js'; // eslint-disable-line
//import 'select2';
// Import local dependencies
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Init Jquery UI select
 */
function initJUIselect(elem) {
  let $field = $(elem);
  let $gfield = $field.closest('.gfield');
  let args = {
    // eslint-disable-next-line no-unused-vars
    change: function (e, ui) {
      $(this).trigger('change');
    },
  };
  if ($gfield.length) {
    args.appendTo = $gfield;
  }
  $field.selectmenu(args).on('change', function () {
    $(this).selectmenu('refresh');
  });
}

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');

  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      setTimeout(function () {
        if ($that.width() / width > $that.height() / height) {
          $(this).css({
            width: '100%',
            height: 'auto',
          });
        } else {
          $(this).css({
            width: ($that.height() * width) / height,
            height: '100%',
          });
        }
      }, 500);
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  // Home page team slider
  $('.carousel').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: 'unslick',
      },
    ],
  });

  // About page slider
  $('.about-welcome__slider').slick({
    arrows: false,
    dots: true,
    slidesToShow: 1,
    slidesToScroll: 1,
  });

  $('.administrators-slider').slick({
    cssEase: 'ease',
    fade: true,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: $('.adm-prev'),
    nextArrow: $('.adm-next'),
  });

  // Render Google Map
  $('.acf-map').each(function () {
    render_map($(this));
  });

  //check for scroll on page
  if ($(window).scrollTop()) $('.header').addClass('scr');

  //testFunc();
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();
  $('.team-list__one .text > div').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  jarallaxElement();
  jarallax(document.querySelectorAll('.jarallax'), {
    speed: 0.9,
    imgPosition: '50% 100%',
  });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    threshold: 0.01,
    once: true,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            var $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  //slick
  $('.testi-list').slick({
    arrows: false,
    dots: true,
    infinite: false,
    speed: 500,
    autoplay: false,
    pauseOnHover: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    rows: 2,
    slidesPerRow: 2,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          rows: 2,
          slidesPerRow: 1,
        },
      },
    ],
  });

  $('.home-team-slider').slick({
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    rows: 1,
  });

  $('.services-slider').slick({
    arrows: false,
    dots: false,
    infinite: false,
    speed: 500,
    autoplay: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    variableWidth: true,
    rows: 1,
  });

  $('.images-slider').slick({
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
  });

  $('.home-testi-slider').slick({
    arrows: true,
    fade: true,
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    rows: 1,
    adaptiveHeight: true,
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = function () {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  // Init Jquery UI select
  $('select')
    .not(
      "#billing_state, #shipping_state, #billing_country, #shipping_country, [class*='woocommerce'], #product_cat"
    )
    .each(function () {
      initJUIselect(this);
    });

  $(document).on('gform_post_render', function (event, form_id) {
    removeFieldPlaceholder();

    $('#gform_' + form_id)
      .find('select')
      .each(function () {
        initJUIselect(this);
      });
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 110 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  var scrollFixed;
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');

      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 1025) {
        scrollFixed = $(window).scrollTop();
        $('.body__inner').addClass('is-active');
      } else {
        $('.body__inner').removeClass('is-active');
        $(window).scrollTop(scrollFixed);
      }
    })
    .on('changed.zf.mediaquery', function () {
      $('.body__inner').removeClass('is-active');
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 1025) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here
  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */

// When section shown in a viewport
function isInViewport(node) {
  let rect = node.getBoundingClientRect();
  return (
    (rect.height > 0 || rect.width > 0) &&
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

$(window).on('scroll', function () {
  let y = $(window).scrollTop(),
    $header = $('.header');

  if (y) {
    if (!$header.hasClass('scr')) $header.addClass('scr');
  } else {
    if ($header.hasClass('scr')) $header.removeClass('scr');
  }

  //Parallax elements
  if ($(window).width() > 1024) {
    var scrolled = $(window).scrollTop();
    $('.parallax-sec').each(function () {
      var initY = $(this).offset().top,
        height = $(this).height();

      // Check if the element is in the viewport
      var visible = isInViewport(this);
      if (visible) {
        var diff = scrolled - initY;
        var ratio = Math.round((diff / height) * 100);
        $(this)
          .find('.parallax-item')
          .css('top', parseInt(-(ratio * 2.5)) + 'px');
        $(this)
          .find('.parallax-item-slow')
          .css('top', parseInt(-(ratio * 1.1)) + 'px');
        $(this)
          .find('.bottom-section__left, .quote-left')
          .css('top', parseInt(-(ratio * 3)) + 'px');
        $(this)
          .find('.bottom-section__right, .quote-right')
          .css('top', parseInt(-(ratio * 3)) + 'px');
      }
    });
  }
});

// ACF Google Map JS code

/*
 *  This function will render a Google Map onto the selected jQuery element
 */

function render_map($el) {
  // var
  let $markers = $el.find('.marker');
  let styles = [
    {
      featureType: 'administrative',
      elementType: 'labels.text.fill',
      stylers: [
        {
          color: '#444444',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2f2f2',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          saturation: -100,
        },
        {
          lightness: 45,
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'all',
      stylers: [
        {
          visibility: 'simplified',
        },
      ],
    },
    {
      featureType: 'road.arterial',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          color: '#91d5e4',
        },
        {
          visibility: 'on',
        },
      ],
    },
  ];

  // vars
  var args = {
    zoom: 14,
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    scrollwheel: false,
    styles: styles,
  };

  // create map
  var map = new google.maps.Map($el[0], args);

  // add a markers reference
  map.markers = [];

  // add markers
  $markers.each(function () {
    add_marker($(this), map);
  });

  // center map
  center_map(map);
}

/*
 *  This function will add a marker to the selected Google Map
 */

var infowindow;
function add_marker($marker, map) {
  // var
  var latlng = new google.maps.LatLng(
    $marker.attr('data-lat'),
    $marker.attr('data-lng')
  );

  // create marker
  const markerObject = {
    url: $marker.data('marker-icon'),
    size: new google.maps.Size(140, 140),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(70, 70),
  };

  let marker = new google.maps.Marker({
    position: latlng,
    map: map,
    icon: markerObject, //uncomment if you use custom marker
  });

  // add to array
  map.markers.push(marker);

  // if marker contains HTML, add it to an infoWindow
  if ($.trim($marker.html())) {
    // create info window
    let offset = [0, 0];

    if ($(window).width() > 1023 && $('.home').length) {
      offset = [390, 300];
    } else {
      offset = [170, 370];
    }

    if ($(window).width() < 1024) {
      if ($('.home').length) {
        offset = [0, 300];
      } else {
        offset = [0, 370];
      }
    }

    infowindow = new google.maps.InfoWindow({
      content: $marker.html(),
      pixelOffset: $('.home').length
        ? new google.maps.Size(offset[0], offset[1])
        : new google.maps.Size($(window).width() < 1024 ? 0 : 50, 480),
    });

    // show info window when marker is clicked
    google.maps.event.addListener(marker, 'click', function () {
      // Close previously opened infowindow, fill with new content and open it
      infowindow.close();
      infowindow.open(map, marker);
    });

    infowindow.open(map, marker);
  }
}

/*
 *  This function will center the map, showing all markers attached to this map
 */
function center_map(map) {
  // vars
  var bounds = new google.maps.LatLngBounds();

  let markerTopMargin = 0,
    markerMargin = 0;
  if ($(window).width() > 1024 && $('.home').length) {
    markerMargin = 0;
  } else {
    markerTopMargin = 0.2;
    markerMargin = 0;
  }

  if ($(window).width() < 768 && $('.home').length) {
    markerTopMargin = 0.5;
    markerMargin = 0;
  }

  // loop through all markers and create bounds
  $.each(map.markers, function (i, marker) {
    var latlng = new google.maps.LatLng(
      marker.position.lat() + markerTopMargin,
      marker.position.lng() + markerMargin
    );
    bounds.extend(latlng);
  });

  map.setCenter(bounds.getCenter());
}
